import React, { useState, useEffect,useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { useAuthService } from '../../services';
import { useNavigate } from 'react-router-dom';
import { InternetUserType } from '../../types/enum/user-type';
import { notify } from '../../util';
import { ApiUrl, NotifyType, PageUrl, SessionKey } from '../../util/app-config';
import { useApiService, useContextService } from '../../services';
import { AppContext } from '../../contexts';

function MIAuthCallback() {
  let [searchParams, setSearchParams] = useSearchParams();
  const { getToken } = useAuthService();
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const { getRegistrationOnEnquiryUser } = useApiService();

  const [tokenResponseVal, setTokenResponse] = useState(null)
  const { putContextInternetUser, putContextRegistration } = useContextService();
  const { message } = notify();

  useEffect(() => {
    var error = searchParams.get("error");
    var errorDescription = searchParams.get("error_description");
    var code = searchParams.get("code");
    var state = searchParams.get("state");

    if (error) {
      message(NotifyType.Error, errorDescription || "MyInfo login failed")
      return;
    }

    if (!code || !state) {
      message(NotifyType.Error, "MyInfo callback is missing authorization data")
      return;
    }

    var tokenRequest = {
      code: code,
      state: state
    }

    const fetchData = async () => {
      let tokenResponse = await getToken(tokenRequest, ApiUrl.MyInfoToken);
      if (tokenResponse && tokenResponse.isValidUser && tokenResponse.internetUser) {
        await putContextInternetUser(tokenResponse.internetUser);
        if (tokenResponse.internetUser.type == InternetUserType.FoodHandler) {
          localStorage.setItem(SessionKey.InternetAuthToken, tokenResponse.token);
          setTokenResponse(tokenResponse)
        } else {
          navigate(PageUrl.Company)
        }
      } else {
        message(NotifyType.Error, "User Login Failed")
      }
    }
    fetchData();
  }, [])

  useEffect(()=>{
    const getRegistrationInfo = async () => {
      if(tokenResponseVal!==null){
        const regOnEnquirey = await getRegistrationOnEnquiryUser(tokenResponseVal.internetUser.nric);
        if (regOnEnquirey) {
          await putContextRegistration(regOnEnquirey, true);
          navigate(PageUrl.Registration);
        }
        else {
          const regData = {
            uinPassport: tokenResponseVal.internetUser.nric,
            name: tokenResponseVal.internetUser.name,
            dob: tokenResponseVal.internetUser.dateOfBirth,
            email: tokenResponseVal.internetUser.email,
            mobile: tokenResponseVal.internetUser.mobileNumber,
          };
          await putContextRegistration(regData, true);
          navigate(PageUrl.Registration);
        }
      }
    }
    getRegistrationInfo();
  },[tokenResponseVal])

  return (
    <div>
      <div>Redirecting.........</div>
    </div>
  );
}

export default MIAuthCallback;
